import PartnerAccountWithdrawalForm from './PartnerAccountWithdrawalForm';

export default PartnerAccountWithdrawalForm;
